module.exports = __webpack_public_path__ + "img/wild_comming.6c365935.png";